import React from 'react';
import 'whatwg-fetch';

import DashletList from './charts/dashletList';
import DashletBarChart from './charts/dashletBarChart';
import DashletPieChart from './charts/dashletPieChart';
import DashletLineChart from './charts/dashletLineChart';

import ModalDashlet from '../components/modal/modalDashletPost';
import ModalDashboard from '../components/modal/modalDashboardPost';
import ModalConfirm from '../components/modal/modalConfirm';
import { deleteEntity } from 'src/utils/entityApi';
import StatsContainer from './components/StatsContainer';
import withAuth from 'src/hoc/withAuth';

const apiIndexDashboard = '/api/dashboard/';

class DashletStatistic extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dashboards: undefined,
      currentDashboard: 0,
      isModalDashletOpen: false,
      isModalDashboardOpen: false,
      isModalDeleteDashboardOpen: false,
      textModal: {
        title: 'Suppression Dashboard',
        message: 'Vous allez supprimer le dashboard',
      },
      dashletClicked: undefined,
    };

    this.openModalDashboard = this.openModalDashboard.bind(this);
    this.openModalDashlet = this.openModalDashlet.bind(this);
    this.openModalDashboard = this.openModalDashboard.bind(this);
    this.updateDashlet = this.updateDashlet.bind(this);
    this.postResult = this.postResult.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.switchDashboard = this.switchDashboard.bind(this);
    this.getDahsboards = this.getDahsboards.bind(this);
    this.onDeleteDashlet = this.onDeleteDashlet.bind(this);
    this.getDashletClicked = this.getDashletClicked.bind(this);
  }

  componentDidMount() {
    this.getDahsboards();
  }

  onDeleteDashlet() {
    this.componentDidMount();
  }
  /*
        Get all the dashboards of the user
     */
  getDahsboards() {
    let queryURL = apiIndexDashboard;
    let graphQL =
      '{ dashboards{ id, title, position, dateCreate, dashlets{id,title, type, dateCreate, position, metadata, dashboard{id}} } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            dashboards: (data['data']['dashboards'] || []).sort((a, b) => a.position - b.position),
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch dashboard: \n' + error);
        }.bind(this)
      );
  }

  switchDashboard(i) {
    this.setState({
      currentDashboard: i,
    });
  }

  openModalDashlet() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDashletOpen: true,
    });
  }

  updateDashlet(dashlet) {
    this.openModalDashlet();
    this.setState({
      dashletClicked: dashlet,
    });
  }

  openModalDashboard() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDashboardOpen: true,
    });
  }

  openModalDeleteDashboard() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteDashboardOpen: true,
    });
  }

  closeModal() {
    this.setState({
      isModalDashletOpen: false,
      isModalDashboardOpen: false,
      isModalDeleteDashboardOpen: false,
      dashletClicked: undefined,
    });
    this.props.toggleBlackOut();
  }

  postResult(type, promise) {
    let message;
    if (type === 'delete-dashboard') {
      message = ' suppression ';
      type = 'dashboard';
      this.setState({
        currentDashboard: 0,
      });
    } else if (type === 'update-dashlet') {
      message = 'Modification ';
      type = 'dashlet';
    } else {
      message = 'création ';
    }
    promise.then(
      function (result) {
        if (result.wentFine) {
          this.props.openToast(true, 'Succès ' + message + type);
          this.componentDidMount();
          if (message === 'Modification ') {
            window.location.reload();
          }
        } else {
          this.props.openToast(false, 'Erreur ' + message + type + '. Veuillez réessayer');
        }
      }.bind(this)
    );
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return true;
    }
    return false;
  }

  /*
        This method render the dashlet corresponding to his type
    */
  renderDashlet(dashletElementGrid) {
    if (dashletElementGrid.dashlet.type === 'dashlet-list') {
      return (
        <DashletList
          key={dashletElementGrid.dashlet.id}
          dashletInfo={dashletElementGrid.dashlet}
          openModal={this.openModalDeleteDashlet}
          openToast={this.props.openToast}
          toggleBlackOut={this.props.toggleBlackOut}
          onDelete={this.onDeleteDashlet}
          onUpdate={this.updateDashlet}
        />
      );
    } else if (dashletElementGrid.dashlet.type === 'dashlet-pie') {
      return (
        <DashletPieChart
          key={dashletElementGrid.dashlet.id}
          dashletInfo={dashletElementGrid.dashlet}
          openModal={this.openModalDeleteDashlet}
          openToast={this.props.openToast}
          toggleBlackOut={this.props.toggleBlackOut}
          onDelete={this.onDeleteDashlet}
          onUpdate={this.updateDashlet}
        />
      );
    } else if (
      dashletElementGrid.dashlet.type === 'dashlet-bar' ||
      dashletElementGrid.dashlet.type === 'dashlet-horizontal-bar'
    ) {
      return (
        <DashletBarChart
          key={dashletElementGrid.dashlet.id}
          dashletInfo={dashletElementGrid.dashlet}
          openModal={this.openModalDeleteDashlet}
          openToast={this.props.openToast}
          toggleBlackOut={this.props.toggleBlackOut}
          onDelete={this.onDeleteDashlet}
          onUpdate={this.updateDashlet}
        />
      );
    } else if (dashletElementGrid.dashlet.type === 'dashlet-lines') {
      return (
        <DashletLineChart
          key={dashletElementGrid.dashlet.id}
          dashletInfo={dashletElementGrid.dashlet}
          openModal={this.openModalDeleteDashlet}
          openToast={this.props.openToast}
          toggleBlackOut={this.props.toggleBlackOut}
          onDelete={this.onDeleteDashlet}
        />
      );
    }
  }

  /*
        This method is used to render a row of the grid depending on the layout of the dashlets
    */
  renderRow(layoutGrid, dashletElementGrid, i) {
    let rowDisplay;
    if (dashletElementGrid['col-md-6'] && dashletElementGrid['row']) {
      if (i !== layoutGrid.length - 1 && !layoutGrid[i + 1]['row'] && layoutGrid[i + 1]['col-md-6']) {
        rowDisplay = (
          <div key={i} className={'row'}>
            <div className={'col-md-6'}>{this.renderDashlet(dashletElementGrid)}</div>
            <div className={'col-md-6'}>{this.renderDashlet(layoutGrid[i + 1])}</div>
          </div>
        );
      } else if (
        i === layoutGrid.length - 1 ||
        i === 0 ||
        (i >= 1 && layoutGrid[i - 1]['row'] && layoutGrid[i + 1]['row'])
      ) {
        rowDisplay = (
          <div key={i} className={'row'}>
            <div className={'col-md-6'}>{this.renderDashlet(dashletElementGrid)}</div>
          </div>
        );
      }
    } else if (dashletElementGrid['col-md-12'] && dashletElementGrid['row']) {
      rowDisplay = (
        <div key={i} className={'row'}>
          <div className={'col-md-12'}>{this.renderDashlet(dashletElementGrid)}</div>
        </div>
      );
    }

    return rowDisplay;
  }

  getDashletClicked() {
    return this.state.dashletClicked;
  }

  render() {
    let layoutGrid = [];

    if (
      this.state.dashboards &&
      this.state.dashboards.length > 0 &&
      this.state.dashboards[this.state.currentDashboard] &&
      this.state.dashboards[this.state.currentDashboard].dashlets
    ) {
      let token = 2;
      for (let i = 0; i < this.state.dashboards[this.state.currentDashboard].dashlets.length; i++) {
        let dashlet = this.state.dashboards[this.state.currentDashboard].dashlets[i];
        let element = {
          row: true,
          'col-md-12': true,
          'col-md-6': false,
          dashlet: dashlet,
        };

        let metadataParsed;
        if (this.isJson(dashlet.metadata)) {
          metadataParsed = dashlet.metadata;
        } else {
          metadataParsed = JSON.parse(dashlet.metadata);
        }

        if (metadataParsed.layout === 'complete-row') {
          token = 0;
        } else if (metadataParsed.layout === 'semi-row') {
          if (token === 1) {
            element['row'] = false;
          }
          token -= 1;
          element['col-md-6'] = true;
          element['col-md-12'] = false;
        }
        if (token === 0) {
          token = 2;
        }
        layoutGrid.push(element);
      }
    }

    return (
      <div className={'dashboard-customizable'}>
        <div className={'container'}>
          {this.state.dashboards && (
            <div className='nav-dashboards'>
              <ul>
                {this.state.dashboards.length > 0 &&
                  this.state.dashboards.map((dashboard, i) => (
                    <li
                      key={i}
                      value={i}
                      onClick={() => this.switchDashboard(i)}
                      className={i === this.state.currentDashboard ? 'currentDashboard' : ''}
                    >
                      {dashboard.title}
                    </li>
                  ))}
              </ul>
              {this.state.dashboards.length > 0 && (
                <button
                  onClick={() => this.openModalDashlet()}
                  type='button'
                  className='btn btn-sm btn-outline-success addDashboard'
                >
                  <span className='icon icon-plus'>Dashlet</span>
                </button>
              )}
              <button
                onClick={() => this.openModalDashboard()}
                type='button'
                className='btn btn-sm btn-outline-success addDashboard'
              >
                <span className='icon icon-plus'>Dashboard</span>
              </button>
              {this.state.dashboards.length > 0 && (
                <button
                  onClick={() => this.openModalDeleteDashboard()}
                  type='button'
                  className='btn btn-sm btn-outline-success addDashboard'
                >
                  <span className='icon icon-cross'>Supprimer</span>
                </button>
              )}
            </div>
          )}

          {(this.props.user || {}).id && <StatsContainer user={this.props.user} />}

          {layoutGrid.length > 0 &&
            layoutGrid.map((dashletElementGrid, i) => this.renderRow(layoutGrid, dashletElementGrid, i))}
        </div>
        <ModalDashlet
          className='myModal'
          isOpen={this.state.isModalDashletOpen}
          onClose={this.closeModal}
          onPostResult={this.postResult}
          openToast={this.props.openToast}
          fromExisting={this.state.dashletClicked ? this.getDashletClicked : undefined}
        />
        <ModalDashboard
          className={'myModal'}
          isOpen={this.state.isModalDashboardOpen}
          onClose={this.closeModal}
          onPostResult={this.postResult}
          openToast={this.props.openToast}
        />
        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteDashboardOpen}
          onSubmit={(type, promise) =>
            this.postResult(
              'delete-dashboard',
              deleteEntity(this.props.authFetch, 'dashboard', this.state.dashboards[this.state.currentDashboard].id)
            )
          }
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />
      </div>
    );
  }
}

export default withAuth(DashletStatistic);
